export const GRD = {
  order: "Для просмотра списка заказов необходимо авторизоваться.",
  common: "Для просмотра данной страницы необходимо авторизоваться",
};

export const endpoints = {
  sale: {
    index: "/api/sale/",
    detail: "/api/sale/category/",
    new: {
      index: "/api/sale/new/",
      detail: "/api/sale/new/category/",
    },
  },
  catalog: {
    index: "/api/catalog/",
    detail: "/api/catalog/category/",
  },
  promo: {
    index: "/api/promo/",
    detail: "/api/promo/category/",
  },
  top: {
    index: "/api/top/",
    detail: "/api/top/category/",
  },
};
